export default {
  toasts: {
    load_error: 'Laskuja ei voitu ladata.',
    action_error: 'Toiminto epäonnistui — yritä uudelleen.',
    finalized: 'Lasku viimeistelty.',
    marked_paid: 'Lasku merkitty maksetuksi.',
  },
  filters: {
    status: 'Suodata tilan mukaan',
  },
  volume_discount_badge: 'Volyymialennus käytössä ({{licenses}} lisenssiä, {{percent}} %)',
  columns: {
    description: 'Lasku',
    status: 'Tila',
    total: 'Yhteensä',
    paid_at: 'Maksettu',
  },
  statuses: {
    pending: 'Odottaa',
    processing: 'Käsittelyssä',
    paid: 'Maksettu',
    failed: 'Epäonnistui',
    refunded: 'Hyvitetty',
    partially_refunded: 'Osittain hyvitetty',
  },
  companies: {
    partner_level: 'Kumppanitason oikaisut',
    columns: {
      company: 'Ravintola',
      buckets: 'Erät',
      amount: 'Summa',
    },
  },
  buckets: {
    license_fees: 'Lisenssimaksut',
    service_fees: 'Palvelumaksut',
    processing_fees: 'Käsittelymaksut',
    delivery_fees: 'Toimitusmaksut',
    gift_card_fees: 'Lahjakorttimaksut',
    adjustments: 'Oikaisut',
  },
  entries: {
    count: '{{count}} merkintää',
    columns: {
      description: 'Merkintä',
      occurred_at: 'Päivämäärä',
      amount: 'Summa',
    },
  },
  incl_tax: 'sis. {{amount}} alv',
  actions: {
    open_invoice_pdf: 'Lataa lasku (PDF)',
    open_hosted: 'Avaa lasku Stripessä',
    export_csv: 'Vie CSV',
    finalize: 'Viimeistele Stripessä',
    mark_paid: 'Merkitse maksetuksi',
  },
  finalize: {
    title: 'Viimeistelläänkö tämä lasku Stripessä?',
    description:
      'Viimeistely käynnistää perinnän: jos maksutapa on tallennettu, veloitus tapahtuu automaattisesti, muuten kumppani saa isännöidyn laskun.',
    confirm: 'Viimeistele',
  },
  mark_paid: {
    pushed_note:
      'Tämä lasku on jo Stripessä — luonnos poistetaan (tai viimeistelty lasku merkitään maksetuksi Stripen ulkopuolella), jotta Stripe lopettaa perinnän.',
    title: 'Merkitäänkö tämä lasku maksetuksi?',
    description:
      'Kirjaa manuaalinen (offline) maksu summasta {{amount}}. Käytä tätä Stripen ulkopuolella kerätyille pankkisiirroille.',
    confirm: 'Merkitse maksetuksi',
  },
  settlement_badge: {
    paid: 'Tulo-osuus tilitetty: {{amount}}',
    other: 'Tulo-osuuden tilitys {{amount}} · {{status}}',
  },
  settlements: {
    title: 'Tulo-osuuden tilitykset',
    retry: 'Yritä uudelleen',
    toasts: {
      load_error: 'Tilityksiä ei voitu ladata.',
      retry_error: 'Uudelleenyritys epäonnistui — yritä uudelleen.',
      retry_paid: 'Tulo-osuus tilitetty.',
      retry_attempted: 'Uudelleenyritys suoritettiin — tilitys ei ole vielä mennyt läpi, tarkista sen tila.',
    },
    columns: {
      period: 'Jakso',
      amount: 'Summa',
      status: 'Tila',
      transfer: 'Siirto',
      paid_at: 'Maksettu',
      payout: 'Tilitys',
    },
    payout: {
      direct: '{{amount}}, ei muuntoa',
      direct_tooltip:
        'Velkaa {{owed}}, muunnettu kurssilla 1 {{payout_currency}} = {{ledger_rate}} {{billing_currency}} ja lähetetty sellaisenaan: ei Stripe-muuntoa, ei maksua.',
      converted: 'Lähetetty {{sent}} → saapui {{arrived}}',
      expected: 'Lähetetty {{sent}} → odotettu {{arrived}}',
      fee: 'Stripen muuntomaksu {{amount}}',
      net: 'netto {{amount}}',
      pending_details: 'Maksu ja netto näkyvät, kun Stripe tilittää siirron.',
      tooltip:
        'Velkaa {{owed}}. Muunnettu kurssilla 1 {{payout_currency}} = {{ledger_rate}} {{billing_currency}}, lähetetty alustan saldosta valuutassa {{source_currency}} ja muunnettu Stripen toimesta kurssilla 1 {{source_currency}} = {{stripe_rate}} {{payout_currency}}. Stripe vähentää {{fee_rate}} % saapuessa.',
    },
    statuses: {
      pending: 'Odottaa',
      held: 'Pidätetty',
      processing: 'Käsittelyssä',
      paid: 'Tilitetty',
      failed: 'Epäonnistui',
      reversed: 'Peruutettu',
    },
    hold_reasons: {
      kyc_incomplete: 'Kumppani ei ole vielä saanut tilitystilin vahvistusta valmiiksi.',
      transfers_inactive: 'Tilitystili ei voi vielä vastaanottaa siirtoja.',
      insufficient_platform_balance: 'Alustan saldo ei riitä tähän tilitykseen juuri nyt.',
      manual_hold: 'Pidätetty manuaalisesti.',
      missing_fx_rate: 'Tilitysvaluutalle ei ole vielä tallennettu vaihtokurssia. Yritetään automaattisesti uudelleen.',
      unsupported_payout_currency: 'Stripe ei voi tilittää tätä tilitystilin valuutassa alustan saldosta.',
      amount_too_small: 'Velkasumma alittaa Stripen vähimmäissiirron tälle valuutalle.',
    },
  },
};
